export const SPOTIFY_LIBRARY_CHUNK_SIZE = 50;
export const SPOTIFY_LIBRARY_DELETE_CHUNK_SIZE = 50;
